/**
 * All available path params across app routes.
 */
export enum AppRoutePathParam {
  Subprocess = 'subprocess',
  Country = 'country',
  Language = 'language',
  VehicleClass = 'vehicleClass',
  VehicleBody = 'vehicleBody',
  VehicleId = 'vehicleId',
  BM = 'bm', // used as static parameter in URL: .../bm/...
  Baumuster = 'baumuster', // not in use
  NST = 'nst', // not in use
  OnlineCode = 'onlinecode',
  ConfigurationStep = 'configurationStep'
}
